/**
 * Guest Validate Fragment
 * Pre-submit checks for the new-account setup form.
 */

import { Events } from '../../../../js/utils/events.js';

let initialized = false;

// ============================================================================
// Guest Validate Handlers
// ============================================================================

const GuestValidateHandlers = {
    /**
     * Only the two checks that hold whatever the org's password policy says:
     * the initial password was typed, and the confirmation matches. Composition
     * and length stay on the server, which knows the active policy and can name
     * what failed — a rule set fixed here would either reject valid passwords
     * or wave invalid ones through.
     */
    onSubmit(event, element) {
        const fields = element.elements;
        if (!fields.initialPassword.value) {
            alert('Initial password is required.');
            event.preventDefault();
            return;
        }
        if (fields.password.value !== fields.confirmPassword.value) {
            alert('The confirmation password does not match.');
            event.preventDefault();
        }
    },
};

// ============================================================================
// Initialization
// ============================================================================

export function initGuestValidate() {
    if (initialized) return;
    initialized = true;

    Events.on('htmx:configRequest', 'guest-validate', GuestValidateHandlers.onSubmit);
}
